const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de materiales de empaque',
  PAGE_DESCRIPTION:
    'Analiza y gestiona todos los aspectos de materiales de empaque de tu almacen desde esta página.'
};

export default HELPER_TEXTS;
